import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=0a5f35a2&scoped=true"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignInButton.vue?vue&type=style&index=0&id=0a5f35a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f35a2",
  null
  
)

export default component.exports